export default __webpack_public_path__ + "static/media/cleanverifylogo.60a79e8c.png";